module.exports = __webpack_public_path__ + "static/media/spinner.e468c388.gif";